import { useState, useEffect } from "react";
import Checkbox from "@mui/material/Checkbox";
import notSelectedCheckboxIcon from "../../../assets/image/icons/tables/checkbox.svg";
import selectedCheckboxIcon from "../../../assets/image/icons/tables/checkbox2.svg";
import selectedCheckboxDisabledIcon from "../../../assets/image/icons/tables/checkbox2-disabled.svg";

import "./style.scss";

const TableSettingsModal = (props) => {
  const [dataSettingsTable, setDataSettingsTable] = useState(
    props.executions
      ? JSON.parse(localStorage?.getItem("executionsGridSettings"))
      : JSON.parse(localStorage?.getItem("contactsGridSettings"))
  );

  useEffect(() => {
    setDataSettingsTable(
      props.executions
        ? JSON.parse(localStorage?.getItem("executionsGridSettings"))
        : JSON.parse(localStorage?.getItem("contactsGridSettings"))
    );
  }, []);

  return (
    <div className="container-settings">
      <div className="settings-table">
        {dataSettingsTable
          ?.filter((el) => el.colId !== "select")
          ?.filter((el) => el.colId !== "created")
          ?.map((item, index) => {
            return (
              <div key={index} className="settings-table__item">
                <Checkbox
                  onChange={() => {
                    const newDataSizeTable = dataSettingsTable.map(
                      (itemData) => {
                        if (itemData.colId === item.colId) {
                          itemData.hide = !itemData.hide;
                        }
                        return itemData;
                      }
                    );
                    setDataSettingsTable(newDataSizeTable);
                  }}
                  disabled={item.colId === "select" || item.colId === "contact"}
                  checked={!item.hide}
                  inputProps={{ "aria-labelledby": "label-" + item.colId }}
                  icon={<img src={notSelectedCheckboxIcon} alt="checkbox" />}
                  checkedIcon={
                    item.colId === "select" || item.colId === "contact" ? (
                      <img
                        src={selectedCheckboxDisabledIcon}
                        alt="disabled checkbox"
                      />
                    ) : (
                      <img src={selectedCheckboxIcon} alt="checkbox" />
                    )
                  }
                  disableRipple={true}
                />

                <label htmlFor={item.colId}>{item.title}</label>
              </div>
            );
          })}
        <div className="line-button" />

        <button
          type="button"
          className="button-apply"
          onClick={() => {
            props.executions
              ? localStorage.setItem(
                  "executionsGridSettings",
                  JSON.stringify(dataSettingsTable)
                )
              : localStorage.setItem(
                  "contactsGridSettings",
                  JSON.stringify(dataSettingsTable)
                );
            props.updateDataSizeTable(dataSettingsTable);
            props.closeModal();
          }}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default TableSettingsModal;
